export default "__VITE_ASSET__1285d545__"